import { makeStyles } from "mui-styles";

export const useStyles = makeStyles((theme) => {
    return {
        Loader: {
        }
    }
});
